// removed by extract-text-webpack-plugin
module.exports = {"SquareIcon":"SquareIcon--12X7t","CircleIcon":"CircleIcon--apz5H","Red":"Red--yccJb","Yellow":"Yellow--ZqDM0","Table":"Table--3f_bK"};


//////////////////
// WEBPACK FOOTER
// ./src/app/components/Pages/SensorsData/Table.scss
// module id = 953
// module chunks = 1